import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览内容",
    links: [
      { label: "动漫资讯", to: "/news" },
      { label: "动画更新", to: "/updates" },
      { label: "角色介绍", to: "/characters" },
      { label: "搜索结果", to: "/search" },
    ],
  },
  {
    title: "社区",
    links: [
      { label: "社区首页", to: "/community" },
      { label: "新番讨论", to: "/community" },
      { label: "动漫推荐讨论区", to: "/community" },
      { label: "创作交流", to: "/community" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "帮助与反馈", to: "/help" },
      { label: "常见问题", to: "/help" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-200">
      <div className="page-wrap py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
                漫
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">
                漫蛙<span className="text-primary-400">2</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              漫蛙2 提供最新动漫资讯、动画更新、角色介绍及动漫社区交流，是动漫爱好者的优选平台。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-message-2-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-200"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link to={link.to} className="text-sm text-background-300 transition-colors hover:text-primary-300">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="page-wrap flex flex-col items-center justify-between gap-3 py-6 text-xs text-background-400 sm:flex-row">
          <p>© 2026 漫蛙2 动漫资讯平台 · 本站内容为演示示范数据，仅供浏览体验</p>
          <p className="flex items-center gap-4">
            <Link to="/help" className="transition-colors hover:text-primary-300">
              帮助中心
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">
              联系我们
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}